import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'


const url = 'sys'
const plural = 'syses'
const single = 'sys'

const api = new ApiCore({
	index: true,
	findOne: false,
	findAll: false,
	create: true,
	update: false,
	remove: false,
	url: url,
	plural: plural,
	single: single
})


api.updatePitstop = (id, payload) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/${id}`, payload)
		.then(handleResponse)
		.catch(handleError);
}






export default api
